export enum ButtonTheme {
  WHITE = 'W',
  FULL_WHITE = 'FW',
  TRANSPARENT_WHITE = 'TW',
  TRANSPARENT_BLACK = 'TB',
  BLUE = 'B',
  RED = 'R',
  ACTION = 'A',
}
